import { useMemo } from 'react'

import { useTravelSearchContext } from '../../context/TravelSearchProvider'

import { TravelDatesResponse, UseTravelDatesResult } from './traveldates-types'

export const useTravelDates = (): UseTravelDatesResult => {
  const { state } = useTravelSearchContext()

  return useMemo(
    () => ({
      homeboundTravelDates: state.homeboundTravelDates,
      isTravelDatesLoading: state.travelDatesApiLoading || !state.outboundTravelDates || (!state.isOneWay && !state.homeboundTravelDates),
      outboundTravelDates: state.outboundTravelDates ?? emptyTravelDates,
      selectedHomeboundDate: state.selectedDates?.homeboundDate,
      selectedOutboundDate: state.selectedDates?.outboundDate,
    }),
    [
      state.travelDatesApiLoading,
      state.outboundTravelDates,
      state.homeboundTravelDates,
      state.isOneWay,
      state.selectedDates?.outboundDate,
      state.selectedDates?.homeboundDate,
    ]
  )
}

const emptyTravelDates: TravelDatesResponse = {
  dates: { fromDate: new Date().toString(), toDate: new Date().toString() },
  defaultDate: '',
  disabledDates: [],
  offerDates: [],
}
